// extracted by mini-css-extract-plugin
module.exports = {"Container":"AccountTips_Container__3PB-J","QRCode":"AccountTips_QRCode__3ZX8x"};